module.exports = __webpack_public_path__ + "static/media/favicon.17677bc2.ico";